import { TabPanel } from "@mui/lab";
import { styled } from "@mui/material";

const MuiTabPanel = styled(TabPanel)({
  padding: "10px 2px", // Remove padding
});

export default MuiTabPanel;
